import styled from "styled-components";
import { colors } from "../../../libs/themes";
import { glassMixin } from "../../../styles";

interface ScrollableListProps {
    scrollable: boolean;
}

// Container to position BigCard
export const Container = styled.div`
    position: relative;
    gap: 0px;
    padding: 0px;
    overflow: visible;
`;

// BigCard styling
export const BigCard = styled.div`
    width: 95%;
    position: relative;
`;

// Sidebar card styling
export const SidebarCard = styled.div`
    position: absolute;
    right: 0px;
    top: 18px;
    height: 95%;
    background: ${colors.background.white};
    border-radius: 24px;
    box-shadow: ${colors.shadow.card};
    padding-top: 10px;
    z-index: 10;

    ${({ theme }) => theme.glassMixin}

    @media (max-width: 900px) {
        right: 0;
    }
`;

// Content inside the sidebar card
export const SidebarCardContent = styled.div`
    white-space: nowrap;
    display: flex;
    flex-direction: column;
    position: relative;
    gap: 16px;
`;

// Styling for scrollable list
export const ScrollableList = styled.div<ScrollableListProps>`
    height: ${({ scrollable }) => (scrollable ? "645px" : "auto")};
    overflow-y: ${({ scrollable }) => (scrollable ? "scroll" : "unset")};
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none; /* IE 10+ */
    padding: 5px 10px 15px 10px;

    &::-webkit-scrollbar {
        display: none; /* Chrome, Safari */
    }

    display: flex;
    flex-direction: column;
    gap: 10px;
`;

// Sidebar card item styling
export const SidebarCardWrapper = styled.div`
    width: 100%;
    display: flex;
    gap: 16px;
`;

export const ScrollButtonWrapper = styled.div`
    position: absolute;
    bottom: -8px;
    right: 85px;
    width: fit-content;
    text-align: center;
    z-index: 15;
    display: flex;
    justify-content: center;
    z-index: 99;
    gap: 10px;

    @media (max-width: 900px) {
        right: 75px;
    }
`;

export const ScrollButton = styled.button`
    width: 50px;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;

    ${glassMixin}
    background-color:rgb(184, 180, 180, 0.5);

    &:hover {
        transform: scale(1.1);
        transition: transform 0.2s ease-in-out;
    }
`;
